import {
  APPLICATION_TYPE_TABLE_META,
  CLAIM_APPLICATION_TYPE_TABLE_META,
  POLICY_LIST_APP_TYPE_TABLE_META,
} from 'data/constants/common_constants';

const TABLE_META_BY_CONTEXT = {
  application: APPLICATION_TYPE_TABLE_META,
  policy: POLICY_LIST_APP_TYPE_TABLE_META,
  claim: CLAIM_APPLICATION_TYPE_TABLE_META,
};

export function getProgramAppTypeTableMeta(value, context = 'application') {
  const options = TABLE_META_BY_CONTEXT[context] || APPLICATION_TYPE_TABLE_META;
  return (
    options.find((item) => item.value === value) || {
      label: value || 'Unknown',
      badge: 'neutral',
    }
  );
}
